<template>
  <div>
    <div class="comments-items">
      <div class="detail-header" @click="toActivityDetail(content)" @touchstart="showDeleteButton()"
                @touchend="emptyTime">
        <div class="user-face">
          <img :src="content.user_face" alt srcset />
        </div>
        <div class="user-info">
          <div class="user-names">{{ content.user_name }}</div>
          <div class="look-info">{{content.create_time_ago}}</div>
        </div>
        <div class="bottom-right"></div>
      </div>
      <div class="activity-desc" @click="toActivityDetail(content)" v-html="content.content" > </div>
      <div
        class="activity-imgs"
        :style="(content.pics_url.length)%3==0 ? 'justify-content: space-between':''"
       >
      
        <div
          v-for="(item,i) in content.pics_url"
          v-if="i<9"
          @click="onImageView(i)"
          :style="(content.pics_url.length)%3==0 ? '':'margin-right:0.1rem'"
        >
          <img :src="item" alt />
        </div>
      </div>

      <div class="activity-detail-bottom">
        <div class="activity-place-box">
          <!--<img src="../../assets/images/activity/Shape@2x.png" alt />-->
          <!--<div class="activity-place">南京新街口</div>-->
        </div>
        <div class="release-time">
          <span>{{content.create_time_ago}}</span>
          <span class="release-time-right">
            <span class="icon-zan-comment-box" v-if="commentShow" ref="comment">
              <img
                @click="onRemoveZan"
                v-if="content.is_zan"
                class="icon-zan0"
                src="../../assets/images/activity/icon-zan-1@2x.png"
                alt
              />
              <span v-else @click="onAddZan">
                <img class="icon-zan1" src="../../assets/images/activity/icon-zan-0@2x.png" alt />赞
              </span>
              <span @click="onSendComment" style="margin-left:20px">
                <img
                  class="icon-zan2"
                  src="../../assets/images/activity/icon-list-comment@2x.png"
                  alt
                />评论
              </span>
            </span>
            <img
              class="icon-shuo-comment"
              @click="onComment"
              src="../../assets/images/activity/icon-shuo-comment@2x.png"
              alt
            />
          </span>
        </div>
      </div>

      <div
        class="comments-detail"
        v-if="content.zan_list.length>0 || content.comment_list.length>0"
      >
        <div class="comments-detail-top"></div>
        <div
          class="zan-box"
          v-if="content.zan_list.length>0"
          :style="content.comment_list.length>0 ? 'border-bottom: 1px solid #e6e6e6;':''"
        >
          <span class="zan-num">{{content.zan_list.length}}赞</span>
          <img
            class="user-zan-face"
            v-for="(zan,i) in content.zan_list"
            :key="i"
            :src="zan.user_face"
            alt
          />
        </div>

        <div
          v-for="(item,i) in content.comment_list"
          :key="i"
          @click="onToUserComment(item)"
          v-if="i<10"
          @touchstart="showCommentDeleteButton(item,i)"
                @touchend="emptyTime"
        >
          <div class="user-comments" style="padding:5px 0 5px 10px" v-if="item.to_user_name==null">
            <span class="comments-user-name">{{ item.user_name }}</span> :
            <span class="comments-user-desc">{{ item.content }}</span>
          </div>
          <div class="user-reply-comments" style="padding-left:10px" v-else>
            <span class="comments-user-name">{{item.user_name}}</span> 回复
            <span class="comments-user-name">{{ item.to_user_name }}</span> :
            <span class="comments-user-desc">{{ item.content }}</span>
          </div>
        </div>
        <div v-if="content.comment_list.length>10" style="padding-left:10px">...</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* 评论 */
.icon-zan0,
.icon-zan1 {
  width: 16px;
  height: 14px;
  margin-right: 5px;
}
.icon-zan2 {
  width: 16px;
  height: 13px;
  margin-right: 5px;
}
.release-time-right {
  display: flex;
  align-items: center;
}
.icon-zan-comment-box {
  /* width: 155px; */
  padding: 0 20px;
  height: 28.5px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-right: 10px;
}
.icon-zan-comment-box span {
  display: flex;
  align-items: center;
}
.release-time-right {
  display: flex;
  align-items: center;
}

.activity-imgs {
  display: flex;
  flex-wrap: wrap;
  margin-left: 40px;
  /* justify-content: space-between; */
  margin-top: 10px;
}
.activity-imgs div {
  width: 1.9rem;
  height: 1.9rem;
  margin-bottom: 0.1rem;
}
.activity-imgs img {
  width: 1.9rem;
  height: 1.9rem;
  object-fit: cover;
}
.comments-detail-top {
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-bottom: 5px solid #f3f3f3;
  position: absolute;
  top: -10px;
  left: 10px;
}
.comments-user-desc {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.comments-user-name {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #586b94;
}

.zan-box {
  display: flex;
  flex-direction: row-reverse;
  padding: 5px 10px;
  /* border-bottom: 1px solid #e6e6e6; */
}

.user-zan-face {
  width: 22px;
  height: 22px;
  border-radius: 22px;
  margin-right: 4px;
}
.zan-num {
  padding: 1px 5px;
  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.comments-detail {
  background: #f3f3f3;
  margin-left: 40px;
  border-radius: 5px;
  /* padding-bottom: 10px; */
  position: relative;
  margin-top: 5px;
}
.activity-desc {
  padding-left: 40px;
}
.activity-detail-bottom {
  padding-left: 40px;
  margin-top: 10px;
}

.release-time {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  margin-left: 5px;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.release-time .icon-shuo-comment {
  width: 25px;
  height: 19px;
}
.activity-place {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  margin-left: 5px;
}
.comments-items {
  width: 6.7rem;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin: 10px auto;
}

.acitve-items {
  width: 6.7rem;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
}
.active-items-title-read {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 58%;
}
.active-item-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}
.active-item-pics {
  width: 40%;
}
.active-item-pics img {
  width: 100%;
  height: 1.4rem;
}
.acitve-item-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
}
.active-itme-read {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.detail-header {
  height: 40px;
  padding: 10px 10px;
  background: #fff;
}
.user-face {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
}
.user-face img {
  height: 32px;
  width: 32px;
}
.user-info {
  margin-left: 5px;
  float: left;
}
.user-info view {
  height: 50px;
  line-height: 50px;
}
.user-names {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.look-info {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(190, 190, 190, 1);
  line-height: 17px;
}
.video-bottom {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-top: 5px;
}
.video-box img {
  margin-top: 10px;
  width: 100%;
}
.active-items-title-read {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 58%;
}
.active-item-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}
.active-item-pics {
  width: 40%;
}
.active-item-pics img {
  width: 100%;
  height: 1.4rem;
}
.acitve-item-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
}
.active-itme-read {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.activity-place-box {
  display: flex;
  align-items: center;
}
.activity-place-box img {
  width: 15px;
  height: 20px;
}
</style>

<script>
import Vue from "vue";

import { getTimeFormat } from "../../utils/date.js";
import { ImagePreview, Field,Toast } from "vant";
Vue.use(ImagePreview).use(Field).use(Toast);

export default {
  name: "Activity4",
  components: {},
  props: {
    content: {
      type: Object,
      default: {}
    },
    index: {
      type: Number,
      default: 0
    }
  },

  data: function() {
    return {
      commentShow: false, //点赞框
      sendShow: false,
       Loop:null
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  methods: {
    showDeleteButton() {
       //删除主题 
      clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
      this.Loop = setTimeout(
        function() {
          // console.log(e)
          if(this.content.is_admin){
            console.log("删除")
            this.$emit("deleteActive",'')
          }
        }.bind(this),
        800
      );
    },
    showCommentDeleteButton(item,i){
      console.log(item,i)
      clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
      this.Loop = setTimeout(
        function() {
          // console.log(e)
          if(item.is_admin){
            console.log("删除")
            this.$emit("deleteComment",i)
          }
        }.bind(this),
        800
      );
    },

    emptyTime() {
      clearTimeout(this.Loop); //清空定时器，防止重复注册定时器
    },
    onImageView(i){
      ImagePreview({
        images:this.content.pics_url,
        startPosition: i})
    },
    toActivityDetail(item) {
      rbLink({
        name:'ActivityDetail',
        query:{
          id: item.id
        }
      });
    },
    onComment() {
      // 显示点赞框
      console.log(this.index);
      this.commentShow = !this.commentShow;
      this.$emit("sendBox", {
        sendShow: false,
        comment_: { id: 0, user_name: "" }
      });
    },
    onSendComment() {
      // 显示评论框
      this.sendShow = true;
      this.commentShow = false;
      this.$emit("sendBox", {
        sendShow: this.sendShow,
        comment_: { id: 0, user_name: "" }
      });
    },
    onToUserComment(item) {
      this.$emit("sendBox", { sendShow: true, comment_: item });
    },
    scrollToTop() {
      this.commentShow = false;
      this.sendShow = false;
      this.$emit("sendBox", {
        sendShow: this.sendShow,
        comment_: { id: 0, user_name: "" }
      });
    },
    onAddZan() {
      let that = this;
      that.$api.post(
        "/api/activity/zanadd",
        { topic_id: this.content.id },
        res => {
          this.content.zan_list.push(res.data)
          this.content.is_zan=true
        },
        res => {
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
              );
              return false;
            }
            this.$emit("loginStatus", true);
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    onRemoveZan() {
      let that = this;
      that.$api.post(
        "/api/activity/zanremove",
        { topic_id: this.content.id },
        res => {
          this.content.zan_list.map((item,i)=>{
            if(item.user_id==res.data.user_id){
            this.content.zan_list.splice(i,1)
            }
          })
          this.content.is_zan=false
        },
        res => {
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
              );
              return false;
            }
            this.$emit("loginStatus", true);
          } else {
            Toast(res.msg);
          }
        }
      );
    }
  },

  filters: {
    getTimeFormat: getTimeFormat
  }
};
</script>




// WEBPACK FOOTER //
// Activity4.vue?22fc2478